/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_ElapsedInputs */



/**
* | output |
* | --- |
* | "Time elapsed" |
*
* @param {Practice_Session_ElapsedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_elapsed = /** @type {((inputs?: Practice_Session_ElapsedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_ElapsedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Verstreken tijd")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Temps écoulé")
	return /** @type {LocalizedString} */ ("Time elapsed")
});